<template>
    <component :is="cardComponent" class="layout-card" :class="cardClasses" :to="route" v-bind="url ? {href: url} : {}">
        <div class="flex flex-1 flex-col space-y-3">
            <image-card
                v-if="image"
                :image="image"
                :imageSet="imageSet"
                :imageSizes="imageSizes"
                :imageAlt="imageAlt"
                :imageAspectRatio="imageAspectRatio"
                :imageObjectFit="imageObjectFit"
                :imageObjectPosition="imageObjectPosition"
                :imageLoading="imageLoading"
                :imagePriority="imagePriority"
            ></image-card>
            <div
                v-if="heading || excerpt"
                class="flex flex-1 flex-col space-y-0.5 bg-inherit px-0 pb-0"
                :class="!image ? 'mt-2' : ''"
            >
                <content-card-heading
                    v-if="heading"
                    :heading="heading"
                    :headingColor="headingColor"
                    :headingComponent="headingComponent"
                ></content-card-heading>
                <content-card-text
                    v-if="excerpt"
                    :contentColor="excerptColor"
                    :html="excerpt"
                    :truncated="true"
                ></content-card-text>
            </div>
        </div>
    </component>
</template>

<script>
export default {
    name: 'LayoutCard',
    props: {
        url: {
            required: false,
            type: String,
            default: null,
        },
        route: {
            required: false,
            type: [String, Object],
            default: null,
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-zinc-50',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'p',
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
        excerptColor: {
            required: false,
            type: String,
            default: 'text-zinc-400',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        image: {
            required: false,
            type: String,
            default: null,
        },
        imageSet: {
            required: false,
            type: String,
            default: null,
        },
        imageSizes: {
            required: false,
            type: String,
            default: null,
        },
        imageAlt: {
            required: false,
            type: String,
            default: '',
        },
        imageAspectRatio: {
            required: false,
            type: String,
            default: undefined,
        },
        imageObjectFit: {
            required: false,
            type: String,
            default: undefined,
        },
        imageObjectPosition: {
            required: false,
            type: String,
            default: undefined,
        },
        imageLoading: {
            required: false,
            type: String,
            default: undefined,
        },
        imagePriority: {
            required: false,
            type: String,
            default: undefined,
        },
    },
    computed: {
        cardComponent() {
            if (this.url) return 'a';
            return this.route ? 'router-link' : 'div';
        },
        cardClasses() {
            const cls = {};
            cls['col-span-1 flex flex-col divide-y overflow-hidden bg-inherit'] = true;
            cls['text-center'] = !!this.textCentered;
            cls['cursor-pointer'] = !!this.route;
            return cls;
        },
    },
};
</script>
